import SocialAPI from 'social/api/social';

const state = {
  posts: [],
  connectedAccounts: [],
  uiFlags: {
    isFetchingPosts: false,
    isFetchingAccounts: false,
    isCreatingPost: false,
    isDeletingPost: false,
    isConnecting: false,
  },
};

const getters = {
  getPosts: $state => $state.posts,
  getConnectedAccounts: $state => $state.connectedAccounts,
  getUIFlags: $state => $state.uiFlags,
};

export const mutations = {
  SET_POSTS($state, posts) {
    $state.posts = posts;
  },
  SET_CONNECTED_ACCOUNTS($state, accounts) {
    $state.connectedAccounts = accounts;
  },
  DELETE_POST($state, postId) {
    $state.posts = $state.posts.filter(p => p.id !== postId);
  },
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export const actions = {
  fetchPosts: async ({ commit }, params = {}) => {
    commit('SET_UI_FLAG', { isFetchingPosts: true });
    try {
      const { data } = await SocialAPI.getPosts(params);
      commit('SET_POSTS', data);
    } finally {
      commit('SET_UI_FLAG', { isFetchingPosts: false });
    }
  },

  fetchAccounts: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingAccounts: true });
    try {
      const { data } = await SocialAPI.getAccounts();
      commit('SET_CONNECTED_ACCOUNTS', data);
    } finally {
      commit('SET_UI_FLAG', { isFetchingAccounts: false });
    }
  },

  createPost: async ({ commit, dispatch }, postData) => {
    commit('SET_UI_FLAG', { isCreatingPost: true });
    try {
      await SocialAPI.createPost(postData);
      await dispatch('fetchPosts');
    } finally {
      commit('SET_UI_FLAG', { isCreatingPost: false });
    }
  },

  deletePost: async ({ commit }, postId) => {
    commit('SET_UI_FLAG', { isDeletingPost: true });
    try {
      await SocialAPI.deletePost(postId);
      commit('DELETE_POST', postId);
    } finally {
      commit('SET_UI_FLAG', { isDeletingPost: false });
    }
  },

  connectAccount: async ({ commit }) => {
    commit('SET_UI_FLAG', { isConnecting: true });
    try {
      const { data } = await SocialAPI.connectAccount('instagram');
      return data.oauth_url;
    } finally {
      commit('SET_UI_FLAG', { isConnecting: false });
    }
  },

  connectPlatform: async ({ commit }, platform) => {
    commit('SET_UI_FLAG', { isConnecting: true });
    try {
      const { data } = await SocialAPI.connectAccount(platform);
      return data.oauth_url;
    } finally {
      commit('SET_UI_FLAG', { isConnecting: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
